import { clientId, GingerMediaApiStorageBaseUrl } from "./baseUrls";

export async function uploadFileWithMetadata(formData: FormData) {
    return fetch(`${GingerMediaApiStorageBaseUrl}/uploadFileWithMetadata?clientId=${clientId}`,
        {
            method: 'POST',
            body: formData
        }
    );
}